export enum Severity {
    SUCCESS = 'success',
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error'
}

export enum MessageSummary {
    SUCCESS = 'Éxito',
    INFO = 'Información',
    WARN = 'Advertencia',
    ERROR = 'Error',
    CONFIRMATION = 'Confirmación'
}
